import { createContext } from 'react'

interface ITranslationProvider {
  currentLanguage: string | null
  updateLanguage: (language: string) => void
}
export const TranslationContext = createContext<ITranslationProvider | null>(
  null
)
